import React, { useState } from 'react'
import { Text, Icon } from '@components/UI'

import File from './File'

const Section = ({
  loadFile,
  data,
  title,
  theme = 'dark',
  downloadable = false,
  preview = false,
  className = ''
}) => {
  const [hidden, hide] = useState(false)
  return (
    <div className={`gp-finder-section ${theme} ${className}`}>
      {title && (
        <div
          className='section-title-container'
          style={hidden ? { paddingBottom: 0 } : {}}
        >
          <Text className='section-title'>{title}</Text>
          {hidden ? (
            <Icon
              name='arrow angle down'
              className='section-control'
              events={{ onClick: () => hide(!hidden) }}
            />
          ) : (
            <Icon
              name='arrow angle up'
              className='section-control'
              events={{ onClick: () => hide(!hidden) }}
            />
          )}
        </div>
      )}
      {!hidden && (
        <div className='section-data'>
          {data.map((v) => (
            <File
              data={v.data}
              status={v.status}
              key={v.data.id || v.data.localId}
              load={loadFile}
              theme={theme}
              downloadable={downloadable}
              preview={preview}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default Section
